import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './AboutOwnerMini.scss';
import classNames from 'classnames';
import { OwnerImageLink } from './OwnerImageLink';

export type AboutOwnerMiniProps = {
  logo?: string | null;
  name: string;
  ownerUrl: string;
  description?: string | null;
  registrationNumber?: string;
  parentOwnerUrl?: string;
  parentOwnerName?: string | null;
};

export const AboutOwnerMini: FunctionComponent<AboutOwnerMiniProps> = ({
  logo,
  name,
  ownerUrl,
  description,
  registrationNumber,
  parentOwnerUrl,
  parentOwnerName,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });

  return (
    <section className={styles.aboutOwnerMini}>
      {logo && (
        <OwnerImageLink
          name={name}
          ownerUrl={ownerUrl}
          qaIdentifier="owner-mini-logo"
          logo={logo}
          variant="mini"
        />
      )}
      <div>
        <h2 className={styles.title}>
          <a className="jg-h4" href={ownerUrl}>
            {name}
          </a>
          {parentOwnerName && (
            <div className="jg-h6" data-qa="parent-owner">
              <span className="jg-text--light">
                {t('common.runby', 'run by ')}
              </span>
              <a className="jg-text--regular" href={parentOwnerUrl}>
                {parentOwnerName}
              </a>
            </div>
          )}
        </h2>
        {description && (
          <p
            data-qa="owner-mini-description"
            className={classNames('jg-space-mbmd', styles.description)}
          >
            {description}
          </p>
        )}
        {registrationNumber && (
          <p
            data-qa="charity-reg"
            className="jg-text--small-light jg-space-mbn"
          >
            {t('charity.registrationNumberLabel', 'Charity Registration No. ')}
            {registrationNumber}
          </p>
        )}
      </div>
    </section>
  );
};

export default AboutOwnerMini;
